import {
  activeStatusOperators,
  CustomMUIChip,
  getColumn,
} from "../../../../common";

export function CreateRequestDetailsTableColumns() {
  let tableColumns = [
    getColumn({
      field: "isActive",
      headerName: "Item Status",
      minWidth: 120,
      filterOperators: activeStatusOperators,

      renderCell: (params) => {
        return (
          <CustomMUIChip
            label={params.value === true ? "Active" : "Inactive"}
            status={params.value}
            variant="outlined"
            color={params.value === true ? "success" : "error"}
          />
        );
      },
    }),
    getColumn({
      field: "itemERPCode",
    }),
    getColumn({
      field: "itemDescription",
      minWidth: 150,
    }),
    getColumn({
      field: "specification",
    }),
    getColumn({
      field: "preferredUnitOfMeasure",
      minWidth: 130,
    }),
    getColumn({
      field: "quantityForSample",
      minWidth: 130,
    }),
    getColumn({
      field: "productClass",
      minWidth: 130,
    }),
    getColumn({
      field: "sampleItemID",
      minWidth: 220,
    }),
  ];

  return tableColumns;
}
